import React from 'react';
import PropTypes from 'prop-types';
import { get, upperFirst } from 'lodash';
import {
  TableRow,
  TableRowColumn,
} from '@unite-us/app-components';
import { browserHistory } from 'common/utils/browserHistory';
import StatusBadge from 'src/pages/facesheet/_id/eligibility/components/StatusBadge';
import {
  getEligibilityAssessmentStatusLabel,
  getLastUpdatedDate,
} from 'src/pages/facesheet/_id/eligibility/utils';

const EligibilityAssessmentTableRow = ({ assessment, contactId, ...rest }) => {
  const statusLabel = getEligibilityAssessmentStatusLabel(
    assessment.status,
    assessment.outreach_status,
  );
  const savedDate = getLastUpdatedDate(assessment);
  const assessmentName = get(assessment, 'template.name') || 'Eligibility Assessment';
  const submitterName = get(assessment, 'facilitator.full_name') || 'N/A';

  const onCellClick = () => {
    browserHistory.push(`/facesheet/${contactId}/eligibility/view/${assessment.id}`);
  };

  return (
    <TableRow
      onCellClick={onCellClick}
      key={assessment.id}
      {...rest}
    >
      <TableRowColumn>
        {assessmentName}
      </TableRowColumn>
      <TableRowColumn>
        {submitterName}
      </TableRowColumn>
      <TableRowColumn>
        <StatusBadge status={upperFirst(statusLabel)} />
      </TableRowColumn>
      <TableRowColumn>
        {get(assessment, 'provider.name', '')}
      </TableRowColumn>
      <TableRowColumn>
        {savedDate}
      </TableRowColumn>
    </TableRow>
  );
};

EligibilityAssessmentTableRow.propTypes = {
  assessment: PropTypes.object.isRequired,
  contactId: PropTypes.string.isRequired,
};

export default EligibilityAssessmentTableRow;
